import type { RelativeDateIntervalUnit } from 'cadenza/relative-date-time/relative-date-interval-unit';
import { relativeDateTimeToInputValues } from 'cadenza/conditions/condition-date-picker/custom-relative-date-time-input-values';

import i18n from './relative-date-time-interval.properties';

/** @see net/disy/lib/interval/relativedate/RelativeDateInterval.java */
export interface RelativeDateTimeInterval {
  from: number;
  to: number;
  unit: RelativeDateIntervalUnit;
}

export function getRelativeDateTimeIntervalLabel (relativeDateTimeInterval: RelativeDateTimeInterval) {
  const { amount, includeCurrent, sign, unit } = relativeDateTimeToInputValues(relativeDateTimeInterval);
  const includeCurrentKey = includeCurrent ? 'including-current' : 'excluding-current';
  return i18n(`label.<${sign}>.<${(unit)}>.<${includeCurrentKey}>`, { count: amount });
}

